import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import LeftArrow3 from '../../assets/img/icons/left_arrow_3.svg';
import RightArrow3 from '../../assets/img/icons/right_arrow_3.svg';
import TaskDropdown from '../../components/CommonFilter/TaskDropdown';
import AddSingleMemberDropdown from '../../components/CustomDropdown/AddSingleMemberDropdown';
import CreateProjectDropdown from '../../components/DropdownStyle/CreateProjectDropdown';
import FilterDropDownStyle from '../../components/DropdownStyle/FilterDropDownStyle';
import ReactDateRangePicker from '../../components/ReactDateRangePicker/ReactDateRangePicker';
import Select from '../../components/ReactSelectDropdown';
import { filterOption } from '../../components/ReactSelectDropdown/ReactSelectDropdown';
import {
  CommonFlex,
  FilterLabel,
  InputWithLabelSection,
} from '../../styledComponents/common';
import { FilterContainer } from '../../styledComponents/tasks';
import { getDateLabel } from '../../utils/helper';
import { FilterButton, IconArrow } from './evidenceStyles';
import SearchWithButton from '../../components/Search/SearchWithButton';

const EvidenceFilter = ({
  selectedOrganization,
  getOrganizationMembersList,
  membersList,
  getOfficesShortList,
  getTasksList,
  officesShortList,
  selectedOffice,
  selectOffice,
  selectedMember,
  selectMember,
  clearMember,
  handleDateChange,
  handleSearchByName,
  handleClearSearch,
  searchTerm,
  onSearchTermChange,
}) => {
  const { t } = useTranslation();
  const [selectedDates, setSelectedDates] = useState({
    startDate: moment().subtract(7, 'days'),
    endDate: moment(),
  });
  const [officeOptions, setOfficeOptions] = useState([
    {
      label: t('all_offices'),
      value: null,
    },
  ]);

  const [taskOptions, setTaskOptions] = useState([
    {
      label: t('all_tasks'),
      value: null,
    },
  ]);

  useEffect(() => {
    getOfficesShortList();
    getOrganizationMembersList({ office_id: null });
    // getTasksList()
  }, []);

  useEffect(() => {
    if (officesShortList && officesShortList.length === 1) {
      getOrganizationMembersList({ office_id: officesShortList[0].id });
    }
    if (officesShortList && officesShortList.length > 1) {
      let newArr = [
        {
          label: t('all_offices'),
          value: null,
        },
      ];
      officesShortList.forEach((office, i) => {
        newArr.push({
          label: office.name,
          value: office.id,
        });
      });
      setOfficeOptions(newArr);
    }
  }, [officesShortList]);

  useEffect(() => {
    if (
      selectedOffice &&
      selectedOffice.value &&
      officesShortList &&
      officesShortList.length > 1
    ) {
      getOrganizationMembersList({ office_id: selectedOffice.value });
    }
  }, [selectedOffice]);

  const selectLastMonth = () => {
    setSelectedDates({
      startDate: moment().subtract(29, 'days'),
      endDate: moment(),
    });
  };
  const selectLastWeek = () => {
    setSelectedDates({
      startDate: moment().subtract(7, 'days'),
      endDate: moment(),
    });
  };
  const onDateApply = () => {
    handleDateChange(selectedDates);
  };

  const onMemberSelect = person => {
    selectMember(person);
  };

  const clearSelectedMember = () => {
    clearMember();
  };

  return (
    <FilterContainer
      admin={localStorage.getItem('user_role') === 'admin'}
      gap="50px"
      columns="170px 250px 50px 250px"
    >
      {localStorage.getItem('user_role') === 'admin' && (
        <InputWithLabelSection>
          <FilterLabel>{t('office')}</FilterLabel>
          <Select
            isSearchable
            value={selectedOffice}
            options={officeOptions}
            placeholder="Select Office..."
            onChange={e => {
              selectOffice(e);
            }}
            styles={CreateProjectDropdown()}
            filterOption={filterOption}
          />
        </InputWithLabelSection>
      )}

        <SearchWithButton
          itemName={''}
          label={t('search_task')}
          searchTermName={t('task_code')}
          searchInput={searchTerm}
          onInputChange={onSearchTermChange}
          handleSearch={handleSearchByName}
          handleClearSearch={handleClearSearch}
        />

      {localStorage.getItem('user_role') === 'admin' && (
        <InputWithLabelSection>
          <FilterLabel>{t('assignee')}</FilterLabel>
          <div style={{ width: `40px` }}>
            <AddSingleMemberDropdown
              assigneeManage={selectedMember}
              updateState={onMemberSelect}
              membersList={membersList}
              clearAssignee={clearSelectedMember}
            />
          </div>
        </InputWithLabelSection>
      )}

      {/* Date Range Picker */}
      <InputWithLabelSection>
        <FilterLabel>{t('date_range')}</FilterLabel>

        <ReactDateRangePicker
          startDate={selectedDates.startDate ? selectedDates.startDate : null}
          startDateId="custom-date-range-start-date"
          endDate={selectedDates.endDate ? selectedDates.endDate : null}
          endDateId="custom-date-range-start-date"
          onDatesChange={setSelectedDates}
          dateDisplayFormat="DD/MM/YYYY"
          onDateSelect={onDateApply}
          selectLastWeek={selectLastWeek}
          selectLastMonth={selectLastMonth}
          disableFutureDates
        />
      </InputWithLabelSection>
    </FilterContainer>
  );
};

export default EvidenceFilter;
